export default {
  name: 'Panorering av tillägg',
  buttons: [
    {
      title: 'Panorering',
      key: '[Blanksteg / mushjul + dra]'
    }
  ]
}
